import service from '@/utils/server';
const modName='/bd/doc/mgr/';
// export const queryList = data => {
//     return service({
//         url: modName+'initDetail',
//         method: 'post'
//     })
// };

//导入方法
export const docUpLoad = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'file',
    method: 'post',
    data
  });
};

/**
 * 图片上传
 */
export const uploadUrl = process.env.BASE_URL + '/common/web/deployment' + '/deployment';



// WEBPACK FOOTER //
// ./src/page/sm/docMgr/api/index.js